import React, { useRef } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { deviceUtils } from "../../utils";

const escapeHtml = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

export default function DeviceQRDialog({ open, handleClose, claimCode, deviceName }) {
  const qrRef = useRef(null);

  const handleEntered = () => {
    if (claimCode && qrRef.current) {
      deviceUtils.renderQRCode(claimCode, qrRef.current);
    }
  };

  const handlePrint = () => {
    const svg = qrRef.current?.querySelector("svg");
    if (!svg) return;
    const printSvg = svg.cloneNode(true);
    printSvg.setAttribute("width", "80mm");
    printSvg.setAttribute("height", "80mm");
    printSvg.setAttribute("preserveAspectRatio", "xMidYMid meet");
    printSvg.style.display = "block";
    printSvg.style.overflow = "visible";

    const win = window.open("", "_blank");
    win.document.write(`
      <html>
        <head><title>QR — ${escapeHtml(deviceName)}</title>
        <style>
          @page { margin: 8mm; }
          * { box-sizing: border-box; }
          body {
            margin: 0;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            background: #fff;
          }
          .print-label {
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            gap: 2mm;
            padding: 4mm;
            background: #fff;
            border: 0.35mm solid #000;
            break-inside: avoid;
            page-break-inside: avoid;
          }
          .qr-code {
            width: 80mm;
            height: 80mm;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fff;
          }
          .qr-code svg {
            width: 80mm;
            height: 80mm;
            display: block;
            overflow: visible;
          }
          p {
            font-family: monospace; font-size: 16pt; font-weight: bold;
            letter-spacing: 0.1em; text-align: center; margin: 0; white-space: nowrap;
          }
        </style>
        </head>
        <body>
          <div class="print-label">
            <div class="qr-code">${printSvg.outerHTML}</div>
            <p>${escapeHtml(claimCode)}</p>
          </div>
          <script>
            window.onload = () => {
              window.focus();
              window.print();
              window.close();
            };
          </script>
        </body>
      </html>
    `);
    win.document.close();
  };

  return (
    <Dialog open={open} onClose={handleClose} TransitionProps={{ onEntered: handleEntered }}>
      <DialogTitle>QR Code — {deviceName}</DialogTitle>
      <DialogContent sx={{ textAlign: "center" }}>
        <div ref={qrRef} />
        <p style={{ fontFamily: "monospace", fontSize: "0.75rem", letterSpacing: "0.05em", marginTop: 8 }}>
          {claimCode}
        </p>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handlePrint}>
          Print
        </Button>
        <Button
          variant="outlined"
          onClick={() => deviceUtils.downloadQRCode(claimCode, deviceName)}
        >
          Download PDF
        </Button>
        <Button variant="contained" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
